import React from 'react';
import { HomeThreeTruths } from './HomeThreeTruths';
import { FAQPageSchema } from '../components/StructuredData';
const homeFAQs = [{
  question: 'What is Vitality Venture Fund?',
  answer: "Vitality is a venture fund investing in deep tech and hard tech solutions rooted in biomimicry, circular systems, and resilience. We fuel startups built on nature's 3.8 billion years of R&D combined with modern advancements in tech and AI."
}, {
  question: 'What is biomimicry investing?',
  answer: "Biomimicry investing applies nature's proven design principles to identify startups creating solutions that are more energy-efficient, resilient, circular, and cost-effective. Vitality uses a biomimicry-based filter to evaluate pre-seed and seed stage companies."
}, {
  question: 'What sectors does Vitality invest in?',
  answer: 'Vitality invests across three themes: Grow (regenerative agriculture and crop production), Build (bio-based construction materials and climate-adaptive infrastructure), and Use (bio-based material innovation including packaging and textiles).'
}, {
  question: 'Who founded Vitality Venture Fund?',
  answer: 'Vitality was founded by Natalya Wallin, GP & Managing Director, who has 10+ years of experience deploying a $75M global fund, backgrounds in biology and molecular genetics, an Executive MBA from Duke, and is a Moab 240-mile ultramarathon finisher.'
}, {
  question: 'What stage companies does Vitality invest in?',
  answer: 'Vitality focuses on pre-seed and seed stage startups in North America and the United Kingdom that leverage biological principles and biomimicry for innovative solutions.'
}, {
  question: 'What companies are in the Vitality portfolio?',
  answer: "Vitality's portfolio includes BOPA (autonomous nano-tractors for regenerative agriculture), TierraSphere (AI for soil regeneration), ReefCycle (nature-based cement), and Mothership Materials (containerized biomanufacturing)."
}];
export function Home() {
  return <>
      <FAQPageSchema faqs={homeFAQs} data-id="element-759" />
      <HomeThreeTruths data-id="element-760" />
    </>;
}